import { Send } from "lucide-react";

const CHANNEL_URL = process.env.REACT_APP_TELEGRAM_CHANNEL_URL || "";

const LABEL = "Daily Sarkari jobs on Telegram";

const VARIANTS = {
  header:
    "inline-flex items-center gap-2 h-9 px-3 rounded-full bg-sky-600 hover:bg-sky-700 text-white text-xs font-semibold whitespace-nowrap transition-colors shadow-sm",
  mobile:
    "flex items-center justify-center gap-2 w-full min-h-11 px-4 rounded-md bg-sky-600 hover:bg-sky-700 text-white text-sm font-semibold transition-colors",
  banner:
    "flex items-center justify-between gap-3 w-full px-4 py-3 rounded-lg bg-gradient-to-r from-sky-600 to-sky-700 hover:from-sky-700 hover:to-sky-800 text-white shadow-sm transition-colors",
};

export default function TelegramPill({ variant = "header", className = "", testId }) {
  if (!CHANNEL_URL) return null;

  const cls = `${VARIANTS[variant] || VARIANTS.header} ${className}`.trim();

  if (variant === "banner") {
    return (
      <a
        href={CHANNEL_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={cls}
        data-testid={testId || "telegram-channel-banner"}
        aria-label={LABEL}
      >
        <span className="flex items-center gap-3">
          <span className="grid place-items-center w-10 h-10 rounded-full bg-white/15">
            <Send className="w-5 h-5" aria-hidden="true" />
          </span>
          <span className="leading-tight">
            <span className="block text-sm font-bold">{LABEL}</span>
            <span className="block text-xs text-sky-50/90">
              New vacancies pushed instantly to your Telegram.
            </span>
          </span>
        </span>
        <span className="hidden sm:inline text-xs font-bold uppercase tracking-wider bg-white/20 px-3 py-1.5 rounded-md">
          Join →
        </span>
      </a>
    );
  }

  return (
    <a
      href={CHANNEL_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={cls}
      data-testid={testId || `telegram-channel-${variant}`}
      aria-label={LABEL}
    >
      <Send className="w-4 h-4" aria-hidden="true" />
      <span>{variant === "mobile" ? LABEL : "Telegram"}</span>
    </a>
  );
}
